import { memo } from 'react';
import kingDown  from './goblin-king/goblin-king-down.png';
import kingUp    from './goblin-king/goblin-king-up.png';
import kingLeft  from './goblin-king/goblin-king-left.png';
import kingRight from './goblin-king/goblin-king-right.png';

const DIR_MAP = {
  up:    kingUp,
  down:  kingDown,
  left:  kingLeft,
  right: kingRight,
};

function toDir(dx, dy) {
  if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return 'down';
  if (Math.abs(dy) >= Math.abs(dx)) return dy < 0 ? 'up' : 'down';
  return dx < 0 ? 'left' : 'right';
}

/**
 * Directional goblin-king PNG sprite (tier boss).
 * Props:
 *   dx / dy — vector boss-centre → player-centre (for facing direction)
 *   size    — rendered width & height in px
 */
export const GoblinKingSprite = memo(function GoblinKingSprite({ dx, dy, size }) {
  const dir = toDir(dx, dy);
  return (
    <img
      src={DIR_MAP[dir]}
      width={size}
      height={size}
      style={{ display: 'block', imageRendering: 'pixelated' }}
      alt=""
    />
  );
});
